<router-outlet></router-outlet>


<footer class="footer">
  <div class="ftr-top">
    <div class="container">
      <div class="row">
        <div class="col-lg-5">
          <div class="ftr-top-lft">
            <a href="index.html" alt="ftr-logo" class="ftr-logo">
              <img src="assets/images/flogo.png" alt="logo">
            </a>
            <p> Book Ambulance in Medical Emergency, Book appointment and Consult Doctor Online, Manage your Medical Records, Order Medicines, Get Exclusive discounts on Lab Tests from registered Diagnostic Test Labs. </p>
            <address>
              E331, Miran Tower, Industiral Area Phase 8B, Mohali
            </address>
            <a href="mailto:support@daktarz.com"> support@daktarz.com </a>
            <!-- <a href="tel:+9915520552"> +91 991 552 0552 </a> -->
          </div>
        </div>
        <div class="col-lg-7">
          <div class="ftr-top-right1">
            <div class="d-md-flex">
              <div class="ftr-right-links" style="width: 180px">
                <h4>Pages</h4>
                <ul>
                  <li><a [routerLink]="['doctors/list']"> Doctor </a></li>
                  <li><a [routerLink]="['hospitals/list']"> Hospital </a></li>
                  <li><a [routerLink]="['labs/list']"> Labs </a></li>
                  <li><a [routerLink]="['pharmacy/list']"> Pharmacy </a></li>
                  <li><a [routerLink]="['blood/list']"> Blood Bank </a></li>
				  <li><a [routerLink]="['articles']"> Articles </a></li>
                </ul>
              </div>
              <div class="ftr-right-links">
                <h4>Important Links</h4>
                <ul>
                  <li><a [routerLink]="['page/TERMS_CONDITIONS']"> Terms & Conditions </a></li>
                  <li><a [routerLink]="['page/PRIVACY_POLICY']"> Privacy Policy </a></li>
                  <li><a [routerLink]="['page/CAREER']"> Careers </a></li>
                  <li><a [routerLink]="['page/CONTACT_US']"> Contact Us </a></li>
                  <li><a [routerLink]="['page/faq']"> FAQ </a></li>
                  <li><a [routerLink]="['page/donate']"> Donate </a></li>
                  <!-- <li><a [routerLink]="null" (click)="openTourism()"> Apply For Medical Tourism </a></li> -->


                </ul>
              </div>
              <div class="ftr-download-app">
                <h4>Download DaktarZ </h4>
                <div class="ftr-download-app-imgs">
                  <a href="https://apps.apple.com/in/app/daktarz/id1445349693" target="_blank"> <img src="assets/images/download-app-store-img-1.png" alt="image"> </a>
                  <a href="https://play.google.com/store/apps/details?id=com.daktarz.user&hl=en" target="_blank"> <img
                      src="assets/images/download-app-store-img-2.png" alt="image"> </a>
                </div>
              </div>
            </div>
            <button (click)="openMedicalTourism()" class="btn btn-primary flash-button"
              data-target="#medicalTourismPopup" data-toggle="modal">
              Apply for Medical Tourism</button>


            <!-- <div class="ftr-btm-newslater">
                <form>
                    <div class="form-group-input">
                        <input type="text" placeholder="Enter your email " class="form-control">
                        <a href="javascript://" class="input-btna-arrow"> <img src="assets/images/arrow-pointing-to-right.png" alt="arrow"> </a>
                    </div>
                </form>
            </div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="ftr-btm">
    <div class="container">
      <div class="ftr-btm-main">
        <div class="ftr-socail">
          <ul>
            <li style="cursor:pointer"><a href="https://www.facebook.com/DaktarZ/" target="_blank"> <i
                  class="fa fa-facebook"> </i></a></li>
            <li style="cursor:pointer"><a href="https://www.instagram.com/daktarz/" target="_blank"> <i
                  class="fa fa-instagram"> </i></a></li>
            <li style="cursor:pointer"><a href="https://twitter.com/daktarzapp" target="_blank"> <i class="fa fa-twitter">
                </i></a></li>
            <li style="cursor:pointer"><a href="https://www.youtube.com/watch?v=Jlbg4kMgYZo" target="_blank"> <i
                  class="fa fa-youtube"> </i></a>
            </li>
            <li style="cursor:pointer"><a href="https://linkedin.com/company/daktarz" target="_blank"> <i
                  class="fa fa-linkedin"> </i></a></li>
          </ul>
        </div>
        <div class="ftr-cpyright text-center">
          <p> Copyrights © 2020 by DaktarZ. All Rights Reserved. </p>
        </div>
      </div>
    </div>
  </div>
</footer>
<app-medical-tourism></app-medical-tourism>

<!-- <input type="hidden" id="medicalTourismTrigger" data-toggle="modal" data-target="#medicalTourismPopup">


<div class="modal fade"  id="medicalTourismPopup">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Medical Tourism</h5>
      </div>



        <div class="modal-body">
            <div class="sign-up-form add-doc-form">
                <div class="add-doc-ambu-cmn add-treat-form">

                    <form  class="doctors-edit-main p-0 no-shadow">
                        <div class="doctors-edit-lft">
                            <div class="edit-profile-form-rows">
                                <div class="row no-gutters">

                                    <div class="col-md-12">
                                        <label> Phone No </label>
                                        <input type="number"
                                        ng2TelInput
                                        [ng2TelInputOptions]="{initialCountry: 'in'}"
                                        (hasError)="hasError($event)"
                                        minlength="10" maxlength="10"
                                        ng2TelInput
                                        [ng2TelInputOptions]="{initialCountry: 'in'}"
                                        (hasError)="hasError($event)"
                                        minlength="10" maxlength="10"
                                        class="form-control"
                                        (keypress)="numberOnly($event,null)"
                                        [(ngModel)]="tourism.phoneNo"
                                        name="phoneNo"

                                        (countryChange)="onCountryChangeTourism($event)"

                                        >

                                    </div>
                                    <div class="col-md-12">
                                        <label> Upload Medical Record </label>
                                        <input type="file" (change)="fileChanged($event)" style="display:none;" #tourismFile class="form-control" name="treatmentRecord"  accept="image/*">
                                        <button (click)="tourismFile.click()" class="btn btn-primary">Upload</button>
                                        <img *ngFor="let record of tourism.medicalRecords" width="60px" height="60px" [src]="record">
                                    </div>
                                    <div class="col-md-12">
                                        <label> Subject </label>
                                        <input type="text" class="form-control" name="treatmentSubject" placeholder="Enter Subject" [(ngModel)]="tourism.subject">
                                    </div>
                                    <div class="col-md-12">
                                        <label> Description </label>
                                        <textarea class="form-control" name="treatmentDescription" placeholder="Enter Description" [(ngModel)]="tourism.description"></textarea>
                                    </div>
                                    <div class="col-md-12">
                                        <div class="add-doc-btns-btm mt-3">


                                            <a [routerLink]="null"  (click)="uploadTourism()" class="btn-style no-shadow"> Save </a>
                                            <a href="javascript://" class="btn-style btn-style-grey  no-shadow" data-dismiss="modal"> Cancel </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>

            </div>
        </div>


    </div>
  </div>
</div>  -->


<div class="modal home-page-modal fade" id="myModal" data-backdrop="static" data-keyboard="false">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content text-center" style="width: 70%;margin: 0 auto;background: #eaeaea;">
      <button type="button" class="close modal-close" data-dismiss="modal" style="position: absolute;z-index: 99999;">&times;</button>
      <div class="modal-body pt-0">
        <img src="/assets/images/logo.png" class="mt-5">
        <h3 class="mt-3 mb-3" style="font-size: 18px;">
          Introducing
          <span style="text-transform: capitalize;">Daktarz</span>
          Lite
        </h3>
        <p style="font-size: 13px;">
          Add
          <span style="text-transform: capitalize;">Daktarz</span>
          to your homescreen to get a better experinece.
        </p>
      </div>
      <button class="add-to-home-button mb-5" data-dismiss="modal" (click)="addToHomeScreen()">Add to
        Homescreen</button>
    </div>

  </div>
</div>